import React from "react";

const AboutUs = () => {
  return (
    <div class="sm:flex items-center max-w-screen-xl">
      <div class="sm:w-1/2 pl-28">
        <div class="text">
          <span class="text-gray-500 border-b-2 border-yellow-600 uppercase">
            About us
          </span>
          <h2 class="my-4 font-bold text-3xl  sm:text-4xl ">
            About <span class="text-yellow-600">Notes App</span>
          </h2>
          <p class="text-gray-700">
            Note-taking is the practice of recording information from different
            sources and platforms. By taking notes, the writer records the
            essence of the information, freeing their mind from having to recall
            everything.
          </p>
        </div>
      </div>
      <div class="sm:w-1/2 py-10 pl-40">
        <div class="image object-center text-center">
        <img src="https://i.ibb.co/QYz8k1L/es-unscreen.gif" alt="" />
        </div>
      </div>
    </div>
  );
};

export default AboutUs;
